if (!customElements.get('product-description-collapse')) {
  customElements.define('product-description-collapse', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.product-description-collapse__content');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;

      this.expanded = false;
      this.onExpand = () => {
        this.expanded = true;
        this.update();
      };
      this.onToggle = () => {
        this.expanded = !this.expanded;
        this.update();
      };
      this.button.addEventListener('click', this.onToggle);
      // Keyboard users must never focus a link hidden by the crop.
      this.content.addEventListener('focusin', this.onExpand);
      this.media = window.matchMedia('(min-width: 768px)');
      this.onResize = () => this.update();
      this.media.addEventListener('change', this.onResize);
      this.observer = new ResizeObserver(this.onResize);
      this.observer.observe(this.content.firstElementChild);
      this.update();
    }

    update() {
      const mode = this.dataset.collapseOn;
      const enabled = mode === 'both' || mode === (this.media.matches ? 'desktop' : 'mobile');
      const height = parseFloat(getComputedStyle(this).getPropertyValue('--description-visible-height'));
      const overflowing = this.content.firstElementChild.getBoundingClientRect().height > height + 1;
      const collapsed = enabled && overflowing && !this.expanded;
      this.toggleAttribute('data-collapsed', collapsed);
      this.button.hidden = !enabled || !overflowing;
      this.button.textContent = collapsed ? this.button.dataset.labelMore : this.button.dataset.labelLess;
      this.button.setAttribute('aria-expanded', String(!collapsed));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.onResize);
      this.button?.removeEventListener('click', this.onToggle);
      this.content?.removeEventListener('focusin', this.onExpand);
    }
  });
}
